export const ANALYSIS_COLORS = [
  { color: "#71f4c8", title: "Green" },
  { color: "#d988e5", title: "Purple" },
  { color: "#c3bfaa", title: "Grey" },
  { color: "#fff100", title: "Yellow" },
  { color: "#f10f16", title: "Red" },
  { color: "#ffdce2", title: "Pink" },
  { color: "#48c3ff", title: "Blue" },
  { color: "#cc46db", title: "Dark purple" },
  { color: "#752c22", title: "Brown" },
  { color: "#ff5d20", title: "Orange" },
  { color: "#ff61be", title: "Dark pink" },
  { color: "#000000", title: "Black" },
];

export const DEFAULT_ANALYSIS_COLOR = null;

export const normalizeAnalysisColor = (value, fallback = "") => {
  const normalizedValue = String(value || "")
    .trim()
    .toLowerCase();

  return /^#[0-9a-f]{6}$/.test(normalizedValue) ? normalizedValue : fallback;
};

export const getAnalysisColorTitle = (value) => {
  const normalizedColor = normalizeAnalysisColor(value);
  const paletteColor = ANALYSIS_COLORS.find(
    (colorOption) => colorOption.color === normalizedColor,
  );

  return paletteColor?.title || normalizedColor;
};

export const compareAnalysisColors = (leftColor, rightColor) => {
  const left = normalizeAnalysisColor(leftColor);
  const right = normalizeAnalysisColor(rightColor);
  const leftPaletteIndex = ANALYSIS_COLORS.findIndex(
    (colorOption) => colorOption.color === left,
  );
  const rightPaletteIndex = ANALYSIS_COLORS.findIndex(
    (colorOption) => colorOption.color === right,
  );
  const leftGroup = leftPaletteIndex >= 0 ? 0 : left ? 1 : 2;
  const rightGroup = rightPaletteIndex >= 0 ? 0 : right ? 1 : 2;

  if (leftGroup !== rightGroup) {
    return leftGroup - rightGroup;
  }

  if (leftGroup === 0) {
    return leftPaletteIndex - rightPaletteIndex;
  }

  return left.localeCompare(right);
};

export const compareAnalysesByColorAndName = (left, right) => {
  const colorComparison = compareAnalysisColors(left?.color, right?.color);

  return (
    colorComparison ||
    String(left?.name || "").localeCompare(
      String(right?.name || ""),
      undefined,
      {
        sensitivity: "base",
      },
    )
  );
};
